// ========================================
// Analytics Modal - מודל אנליטיקס
// ========================================
import React from 'react';
import { X, PieChart } from 'lucide-react';
import StockTreemap from './StockTreemap';

/**
 * מודל אנליטיקס עם Treemap
 */
const AnalyticsModal = ({ isOpen, onClose, items, forecastFactor, onItemClick }) => {
    if (!isOpen) return null;

    const handleItemClick = (item) => {
        onClose(); // סגור את המודל
        onItemClick(item); // פתח את פרטי הפריט
    };

    return (
        <div
            className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 backdrop-blur-sm p-4"
            dir="rtl"
            onClick={onClose}
        >
            <div
                className="bg-white w-full max-w-4xl rounded-2xl shadow-2xl overflow-hidden flex flex-col max-h-[90vh]"
                onClick={(e) => e.stopPropagation()}
            >
                {/* Header */}
                <div className="relative bg-gradient-to-br from-violet-600 to-indigo-700 p-5 text-white">
                    <button
                        onClick={onClose}
                        className="absolute left-4 top-4 p-2 hover:bg-white/10 rounded-xl transition-colors"
                    >
                        <X size={20} />
                    </button>

                    <div className="flex items-center gap-3">
                        <div className="p-3 bg-white/20 rounded-xl">
                            <PieChart size={24} />
                        </div>
                        <div>
                            <h2 className="text-xl font-bold">אנליטיקס - מפת מלאי</h2>
                            <p className="text-white/80 text-sm mt-0.5">
                                ויזואליזציה של התפלגות המלאי לפי שווי וסטטוס
                            </p>
                        </div>
                    </div>
                </div>

                {/* Body */}
                <div className="p-6 overflow-y-auto flex-1">
                    <StockTreemap
                        items={items}
                        forecastFactor={forecastFactor}
                        onItemClick={handleItemClick}
                    />
                </div>

                {/* Footer */}
                <div className="p-4 border-t border-gray-100 bg-gray-50/50 text-center">
                    <button
                        onClick={onClose}
                        className="px-6 py-2.5 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-xl font-semibold transition-colors"
                    >
                        סגור
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AnalyticsModal;
